import React, {Component} from 'react';
import {getNumber, isValidURL} from "../../../../utils/isValidUrl";

export default class TableRow extends Component {
    state = {
        infoRowVisible: false,
        mobileRowVisible: false,
        editing: false,
        url: this.props.rowData.url,
    };

    toggleTableRow = rowName => () => {
        if (this.state[rowName]) {
            this.setState({[rowName]: false});
        } else {
            this.setState({[rowName]: true});
        }
    };

    toggleEditingState = () => {
        if (this.state.editing) {
            this.setState({editing: false});
        } else {
            this.setState({editing: true});
        }
    };

    handleEditInputChange = e => {
        this.setState({url: e.target.value});
    };

    handleEditSuccess = async () => {
        const {url} = this.state;
        const inputs = [...new Set(url.split('\n'))];
        const urls = inputs.filter(input => isValidURL(input));
        const invalidUrls = inputs.filter(input => !isValidURL(input.trim()) && input.length);
        const apikey = this.props.user && this.props.user.apikey ? this.props.user.apikey : process.env.REACT_APP_API_KEY;
        this.props.handleInvalidUrls(invalidUrls);
        this.props.requestAPI(urls, apikey, this.props.user);
        this.props.handleDeleteTableRow(this.props.index);
        if (url) {
            this.setState({
                url: '',
                inputSize: 'single',
            });
        }
    };

    handleEditCancel = () => {
        this.setState({
            url: this.props.rowData.url,
            editing: !this.state.editing
        });
    };

    render() {
        const {rowData, index, handleDeleteTableRow, invalidUrlMessage} = this.props;
        const {
            data: {Facebook, Pinterest},
        } = rowData;

        // Mobile line toggling
        const mainRowClassName = this.state.mobileRowVisible ? 'tb-line tb-line_active' : 'tb-line';

        // Info line togglling
        const infoRowClassName = this.state.infoRowVisible
            ? 'tb-line-info tb-line-info_active'
            : 'tb-line-info';

        const tableUrlClassName = this.state.editing ? 'tb-url tb-url_editing' : 'tb-url';

        const editIconClassName = this.state.editing
            ? 'tb-actions__edit tb-actions__edit_hidden'
            : 'tb-actions__edit';

        const checkIconClassName = this.state.editing
            ? 'tb-actions__check tb-actions__check_visible'
            : 'tb-actions__check';

        const cancelIconClassName = this.state.editing
            ? 'tb-actions__cancel tb-actions__cancel_visible'
            : 'tb-actions__cancel';

        return this.props.isInvalid ? [<tr className="tb-line" key="main-row">
            <td className="centered light-text table-index-hide">{index}</td>
            <td className="tb-url">
                <span className="tb-url__value">{this.state.url}</span>
                <span className="tb-actions">
                    <span className="tb-actions__trash"
                          onClick={() => this.props.handleDeleteInvalidUrlRow(this.state.url)}/>
                </span>
            </td>
            <td className="tb-data">
                {invalidUrlMessage}
            </td>
            <td className="tb-data">{invalidUrlMessage}</td>
            <td className="tb-data tb-data__total">
                {invalidUrlMessage}
            </td>
        </tr>] : [
            <tr className={mainRowClassName} key="main-row">
                <td className="centered light-text table-index-hide">{index}</td>
                <td className={tableUrlClassName}>
                    <span className="tb-url__value">{this.state.url}</span>
                    <input
                        className="tb-url__input"
                        placeholder={this.state.url}
                        value={this.state.url}
                        onChange={this.handleEditInputChange}
                    />
                    <span className="tb-actions">
                        <span className={editIconClassName} onClick={this.toggleEditingState}/>
                        <span className={cancelIconClassName} onClick={this.handleEditCancel}/>
                        <span className={checkIconClassName} onClick={this.handleEditSuccess}/>
                        <span className="tb-actions__trash" onClick={() => handleDeleteTableRow(index)}/>
                    </span>
                </td>
                <td className="tb-data tb-data_face" onClick={this.toggleTableRow('infoRowVisible')}>
                    {getNumber(Facebook.total_count)}
                </td>
                <td className="tb-data tb-data_pins">{getNumber(Pinterest)}</td>
                <td className="tb-data tb-data__total">
                    {getNumber(Facebook.total_count + Pinterest)}
                </td>
                <td>
                    <span className="tb-toggle" onClick={this.toggleTableRow('mobileRowVisible')}/>
                </td>
            </tr>,
            <tr className={infoRowClassName} key="info-row">
                <td className="tb-line-info__line"/>
                <td>
                    <span className="tb-line-info__text">Shares:</span>
                    <span className="tb-line-info__text">Comments:</span>
                    <span className="tb-line-info__text">Comments Plugin:</span>
                    <span className="tb-line-info__text">Reactions:</span>
                </td>
                <td>
                    <span className="tb-line-info__text tb-line-info__text_left tb-line-info_face">
                        {getNumber(Facebook.share_count)}
                    </span>
                    <span className="tb-line-info__text tb-line-info__text_left">
                        {getNumber(Facebook.comment_count)}
                    </span>
                    <span className="tb-line-info__text tb-line-info__text_left">
                        {getNumber(Facebook.comment_plugin_count)}
                    </span>
                    <span className="tb-line-info__text tb-line-info__text_left">
                        {getNumber(Facebook.reaction_count)}
                    </span>
                </td>
            </tr>,
        ];
    }
}
